export default __webpack_public_path__ + "static/media/dataSciencePreview.d489caf3.jpg";